<script lang="ts">
  import { onMount } from 'svelte';
  import { fly } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import { MessageIcon, PhoneAltIcon } from '$icons';
  import { page } from '$app/stores';
  import type { GlobalProperties } from 'customer-components/lib/types';
  import {
    getHref,
    getTextColor,
  } from 'customer-components/lib/helpers/sections-helper';

  export let settings: GlobalProperties;

  $: console.log('settings', settings);

  let show = false;

  const stickyIcons = {
    Phone: PhoneAltIcon,
    SMS: MessageIcon,
    Section: MessageIcon,
  };

  onMount(() => {
    checkHeaderVisibility();
  });

  function checkHeaderVisibility() {
    let myElement = document.getElementsByTagName('header')[0];
    let counter = 0;

    if (myElement || counter > 2) {
      // Element is found, do something with it
      updateVisibility();
    } else {
      // Element is not yet present, check again after a delay
      counter++;
      setTimeout(checkHeaderVisibility, 1);
    }
  }

  const updateVisibility = () => {
    show = !(window.scrollY <= 150);
  };

  function sendEvent(eventName) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        lpKey: $page.data.businessName,
      });
    } catch (err) {
      console.log(err);
    }
  }
</script>

<svelte:window on:scroll={updateVisibility} />

<div
  class="mobile-controls"
  class:show
  role="button"
  tabindex="-1"
  transition:fly={{ duration: 400, y: 56, opacity: 1, easing: quintOut }}
>
  {#if settings.mktSettings?.stickyButtons.buttons.length > 0}
    {#each settings.mktSettings?.stickyButtons.buttons as button, index}
      {#if button.label.length > 0}
        <a
          href={getHref(button.link_type, button.link)}
          class="cta-button"
          style={button.background_color === 'default'
            ? index === 0
              ? 'background:var(--color-primary);color:var(--color-neutral-white);font-family:var(--font-family-intertight)'
              : 'background:var(--color-accent);color:var(--color-accent-text);font-family:var(--font-family-intertight)'
            : `background:${button.background_color};color:${getTextColor(button.background_color)};font-family:var(--font-family-intertight)`}
          on:click={() => sendEvent('stickyButtonFormClick')}
        >
          <svelte:component this={stickyIcons[button.link_type]} />
          <span>{button.label}</span>
        </a>
      {/if}
    {/each}
  {/if}
</div>

<style>
  .mobile-controls {
    position: fixed;
    bottom: 0;
    left: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    width: 100%;
    height: auto;
    border: none;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.14px;
    z-index: 21;
    transform: translateY(80px);
    transition: 0.3s ease-in-out;
  }
  .mobile-controls.show {
    transform: translateY(0);
  }

  .cta-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: none;
    text-decoration: none;
    gap: 6px;
    font-weight: 600;
    padding: 10px 0;
    padding-bottom: 20px;
    font-size: 16px;
  }

  .cta-button:not(:last-child) {
    border-right: 1px solid var(--neutral-grey-90);
  }

  @media screen and (min-width: 768px) {
    .mobile-controls {
      display: none;
    }
  }
</style>
